var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { style: { height: _vm.theTableHeight + "px" } },
    [
      _c("div", { staticClass: "simple-form flex col-4 label" }, [
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.goodsOrder.no))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.goodsOrder.sellerName))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(2),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _vm.goodsOrder.shipState == 0
              ? _c("span", [_vm._v(" 商家未发货，联系商家")])
              : _vm._e(),
            _vm._v(" "),
            _vm.goodsOrder.shipState != 0 && _vm.goodsOrder.recvState == 0
              ? _c("span", [_vm._v("商家已发货，等待确认收货")])
              : _vm._e(),
            _vm._v(" "),
            _vm.goodsOrder.shipState != 0 && _vm.goodsOrder.recvState == 1
              ? _c("span", [_vm._v("已部分收货")])
              : _vm._e(),
            _vm._v(" "),
            _vm.goodsOrder.shipState != 0 && _vm.goodsOrder.recvState == 2
              ? _c("span", [_vm._v("已收货")])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(3),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.goodsOrder.state))])
          ])
        ]),
        _vm._v(" "),
        _vm.goodsOrder.cancelled
          ? _c("div", { staticClass: "form-group center" }, [
              _vm._m(4),
              _vm._v(" "),
              _c("div", { staticClass: "form-value" }, [
                _c("span", [_vm._v(_vm._s(_vm.goodsOrder.cancelCause))])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.goodsOrder.postscript != null
          ? _c("div", { staticClass: "form-group center" }, [
              _vm._m(5),
              _vm._v(" "),
              _c("div", { staticClass: "form-value" }, [
                _c("span", [_vm._v(_vm._s(_vm.goodsOrder.postscript) + " ")])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(6),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.goodsOrder.shipAborted ? "是" : "否") + " ")
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(7),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(
                _vm._s(_vm.goodsOrder.signConfirmNeeded ? "是" : "否") + " "
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(8),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.goodsOrder.onlineSignFlag ? "是" : "否") + " ")
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(9),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.signStatusMap[_vm.goodsOrder.signStatus]) + " ")
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("swb-result-table", {
        ref: "result_table",
        attrs: {
          name: "result_table",
          confKey: _vm.confKey,
          configAuto: true,
          needPager: _vm.needPager,
          rowNoShow: _vm.rowNoShow,
          rowNoFixed: _vm.rowNoFixed,
          btnColName: _vm.btnColName,
          btnColTitle: _vm.btnColTitle,
          btnColWidth: _vm.btnColWidth,
          btnColFixed: _vm.btnColFixed,
          pageNoChangeHandler: _vm.handlePageChange,
          tableHeight: _vm.tableHeight,
          rowDblClickHandler: _vm.rowDblClickHandler
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("订单编号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("商家")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("交付状态")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("订单状态")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("取消原因")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("买家附言")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("无需继续发货")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("是否需要签署确认")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("是否在线签署")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("签署状态")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-01bcf5f6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01bcf5f6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/order/GoodsOrderInfo.vue
// module id = 2678
// module chunks = 0